// src/context/HabitContext.js

import React, { createContext, useState, useEffect } from 'react';

// Create a context for managing habits
export const HabitContext = createContext();

// Provider component to wrap the app and provide habit state
export const HabitProvider = ({ children }) => {
  const [habits, setHabits] = useState([]);

  // Load habits from localStorage on mount
  useEffect(() => {
    const storedHabits = localStorage.getItem('habits');
    if (storedHabits) {
      setHabits(JSON.parse(storedHabits));
    } else {
      // Initialize with default habits if none are stored
      setHabits([
        { id: 1, name: 'Brushing Teeth', streak: 0, completed: false, icon: 'FaTooth' },
        { id: 2, name: 'Weightlifting', streak: 0, completed: false, icon: 'FaDumbbell' },
        { id: 3, name: 'Drinking Water', streak: 0, completed: false, icon: 'FaTint' },
      ]);
    }
  }, []);

  // Save habits to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('habits', JSON.stringify(habits));
  }, [habits]);

  return (
    <HabitContext.Provider value={{ habits, setHabits }}>
      {children}
    </HabitContext.Provider>
  );
};
